import { createAction } from "typesafe-actions";

import { dsDashboardTypes } from "./types";

export const setSelectedDeleteTable = createAction(dsDashboardTypes.SET_SELECTED_DELETE_TABLE)<any>();

export const setSelectedEditTable = createAction(dsDashboardTypes.SET_SELECTED_EDIT_TABLE)<any>();

export const setActiveDashboardViews = createAction(dsDashboardTypes.SET_ACTIVE_DASHBOARD_VIEWS)<any>();

export const setDashboardViewData = createAction(dsDashboardTypes.SET_DASHBOARD_VIEW_DATA)<any>();

export const setErdViewMetaData = createAction(dsDashboardTypes.SET_ERD_VIEW_METADATA)<any>();

export const setGeneratedProtobufData = createAction(dsDashboardTypes.SET_GENERATED_PROTOBUF_DATA)<any>();

export const setSqlViewData = createAction(dsDashboardTypes.SET_SQL_VIEW_DATA)<any>();
